/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * Module imports.
 */
import { DatePickerModule } from './../../common/calender/datepicker/date-picker.module';
import { PipesModule } from './../../pipes/pipes.module';
import { ModalModule } from 'ngx-bootstrap/modal';

/**
 * Component imports.
 */
import { WebCalendarActionsComponent } from './web-calendar-actions.component';



@NgModule({
  declarations: [
    WebCalendarActionsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    PipesModule,
    DatePickerModule
  ],
  exports: [
    WebCalendarActionsComponent
  ]
})
export class WebCalendarActionsModule { }
